import React from 'react';

const config = {
  ok:        { label: 'Freigegeben', color: 'var(--ok)',    bg: 'var(--ok-bg)',    border: 'var(--ok-border)',    icon: '✓' },
  warning:   { label: 'Prüfen',      color: 'var(--warn)',  bg: 'var(--warn-bg)',  border: 'var(--warn-border)',  icon: '⚠' },
  error:     { label: 'Fehler',      color: 'var(--error)', bg: 'var(--error-bg)', border: 'var(--error-border)', icon: '✕' },
  uncertain: { label: 'Unklar',      color: 'var(--warn)',  bg: 'var(--warn-bg)',  border: 'var(--warn-border)',  icon: '?' },
};

export default function StatusBadge({ status, size = 'md' }) {
  const c = config[status] || config.uncertain;
  const pad = size === 'sm' ? '3px 8px' : '4px 12px';
  const fs  = size === 'sm' ? '11px' : '12px';
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 5,
      padding: pad, fontSize: fs, fontFamily: 'Syne, sans-serif',
      fontWeight: 600, letterSpacing: '0.04em',
      color: c.color, background: c.bg,
      border: `1px solid ${c.border}`, borderRadius: 6,
      whiteSpace: 'nowrap',
    }}>
      <span style={{ fontSize: size === 'sm' ? 10 : 12 }}>{c.icon}</span>
      {c.label}
    </span>
  );
}
